// Shared utility functions for ProjectCalculator components

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatCurrencyInput = (amount: number) => {
  if (amount === 0) return '';
  return new Intl.NumberFormat('en-US').format(amount);
};

export const parseCurrencyInput = (value: string) => {
  // Remove all non-digit characters except decimal points
  const cleaned = value.replace(/[^\d.]/g, '');
  return parseFloat(cleaned) || 0;
};

export const handleCurrencyInputChange = (value: string, setter: (value: number) => void) => {
  const numericValue = parseCurrencyInput(value);
  setter(numericValue);
};
